import script from "./BlueCheckIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueCheckIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__